import { persist } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'
import { createWithEqualityFn as create } from 'zustand/traditional'
import { shallow } from 'zustand/vanilla/shallow'

import { createSelectors } from '@/shared/lib/createSelectors.ts'

interface State {
	cookiesAccepted: boolean
}

interface Actions {
	setCookiesAccepted: (value: boolean) => void
}

export const useCookiesStoreBase = create<State & Actions>()(
	persist(
		immer(set => ({
			cookiesAccepted: false,

			setCookiesAccepted: value =>
				set(state => {
					state.cookiesAccepted = value
				})
		})),
		{
			name: 'cookies-store-v0' // name of the item in the storage (must be unique)
			// by default, 'localStorage' is used
		}
	),
	shallow
)

export const useCookiesStore = createSelectors(useCookiesStoreBase)
